import { Route, Routes } from "react-router-dom";
import { N1PlansEdit } from "./edit";
import { N1PlansTable } from "./table";
import { N1PlansNew } from "./new";

export default function E2DynamicData() {
  return (
    <Routes>
      <Route path=":id" element={<N1PlansEdit />} />
      <Route index element={<N1PlansTable />} />
      <Route path="new" element={<N1PlansNew />} />
    </Routes>
  );
}
